export const routes = [
  // public pages
  {
    path: '/',
    meta: {
    },
    component: () => import('@/views/layout-public/Index'),
    children: [
      // Home
      {
        name: 'Home',
        title: '',
        path: '',
        component: () => import('@/views/public/Index'),
      },
      // About
      {
        name: 'About ezWave',
        path: 'about-us',
        component: () => import('@/views/public/About'),
      },
      // About
      {
        name: 'Careers',
        path: 'careers',
        component: () => import('@/views/public/Careers'),
      },
      // Help
      {
        name: 'Help and Support',
        path: 'help',
        component: () => import('@/views/public/Help'),
      },
      // FAQ
      {
        name: 'FAQ',
        path: 'faq',
        component: () => import('@/views/public/Faq'),
      },
      // Plans and pricing
      {
        name: 'Plans and Pricing',
        path: 'plans',
        component: () => import('@/views/public/Plans'),
      },
      // Privacy
      {
        name: 'Privacy Policy',
        path: 'privacy',
        component: () => import('@/views/public/Privacy'),
      },
      // Signup
      {
        name: 'Signup',
        path: 'signup',
        component: () => import('@/views/public/Signup'),
      },
      // Terms of Service
      {
        name: 'Terms of Service',
        path: 'terms',
        component: () => import('@/views/public/Terms'),
      },
      {
        path: 'login',
        component: () => import('@/views/public/Login'),
      },
      {
        path: 'password-reset',
        component: () => import('@/views/public/PasswordReset'),
      },
      {
        path: 'register',
        component: () => import('@/views/public/Register'),
      },
    ],
  },
  {
    path: '/entrance/login',
    component: () => import('@/views/entrance/Login'),
  },
  {
    path: '/signup/new',
    component: () => import('@/views/signup/index'),
  },
  {
    path: '/signup/upgrade',
    component: () => import('@/views/signup/upgrade'),
  },
  {
    name: 'Appointment',
    path: '/appointment',
    meta: {
      // requiresAuth: true
    },
    component: () => import('@/views/entrance/appointment'),
    props: (route) => ({ apptID: route.query.apptID, secret: route.query.secret }),
  },
]
